import leaflet from 'leaflet'
import Layer from './Layer'
import Proj from 'proj4leaflet'
import { withMapContext } from '../Leaflet/mapContext'
import { mapColorCategory } from '../../selectors/stompunkt'

class GeoJsonLayer extends Layer {

    layer = undefined

    createMarker(feature, coords){

        leaflet.LatLng.prototype.distanceTo = function(other) {
            var dx = other.lng - this.lng;
            var dy = other.lat - this.lat;
            return Math.sqrt(dx * dx + dy * dy);
        }

        let category = mapColorCategory(feature);

        let marker = leaflet.circleMarker(coords, {                
            interactive: this.props.onClick != null
        });

        let map = this.props.map;
        let currentPoint = map.latLngToContainerPoint(coords);
        
        var width = 16;
        var height = 16;
        var xDifference = width / 2;
        var yDifference = height / 2;

        switch(category){
            case "riksavvägningen": { // Höjdpunkter
                marker = leaflet.circleMarker(coords,{alt: ''}) // Endast en cirkel för höjd punkter
                break;
            }
            case "rix95": { // Plan, klass 2
                width = 16;
                height = 16;
                xDifference = width / 2;
                yDifference = height / 2;
                var p1_romb = leaflet.point(currentPoint.x, currentPoint.y + yDifference); // Nedre spetsen av romben
                var p2_romb = leaflet.point(currentPoint.x + xDifference, currentPoint.y); // Midjan, till vänster av romben
                var p3_romb = leaflet.point(currentPoint.x, currentPoint.y - yDifference); // Övre spetsen av romben
                var p4_romb = leaflet.point(currentPoint.x - xDifference, currentPoint.y); // Midjan, till höger av romben

                marker = leaflet.polygon([map.containerPointToLatLng(p1_romb),map.containerPointToLatLng(p2_romb),map.containerPointToLatLng(p3_romb),map.containerPointToLatLng(p4_romb)],{alt: ''});
                break;
            }
            case "sweref": { // Plan, klass 1
                width = 12;
                height = 12;
                xDifference = width / 2;
                yDifference = height / 2;
                var southWest = leaflet.point((currentPoint.x - xDifference), (currentPoint.y - yDifference));
            var northEast = leaflet.point((currentPoint.x + xDifference), (currentPoint.y + yDifference));
                var bounds = leaflet.latLngBounds(map.containerPointToLatLng(southWest),map.containerPointToLatLng(northEast));
                marker = leaflet.rectangle(bounds,{alt: ''});
                break;
            }
            case "förstörd": { // Förstörda punkter
/*                 marker = leaflet.circleMarker(coords,{alt: ''}) // Endast en cirkel för förstörda punkter
                break; */
                width = 16;
                height = 16;
                xDifference = width / 2;
                yDifference = height / 2;
                var p1_triangle = leaflet.point(currentPoint.x + xDifference, currentPoint.y + yDifference); // Vänstra punkten i basen av triangeln
                var p2_triangle = leaflet.point(currentPoint.x, currentPoint.y - yDifference); // Övre spetspunkten i triangeln
                var p3_triangle = leaflet.point(currentPoint.x - xDifference, currentPoint.y + yDifference); // Högra punkten i basen av triangeln

                marker = leaflet.polygon([map.containerPointToLatLng(p1_triangle),map.containerPointToLatLng(p2_triangle),map.containerPointToLatLng(p3_triangle)],{alt: ''});

                break;
            }
            default: {
                break;
            }
        }

        return marker;
    }

    createLayer() {
        return Proj.geoJson(this.getData(), {
            pointToLayer: (feature, coords) => this.createMarker(feature,coords, {
                interactive: this.props.onClick != null
            }),
            style: this.props.style,
            onEachFeature: (feature, layer) => {
                if (this.props.onClick) {
                    layer.on('click', (e) => this.props.onClick(e.target.feature, e.originalEvent))
                }
                if (this.props.tooltip) {
                    layer.bindTooltip(this.props.tooltip(feature), {
                        direction: 'top',
                        className: 'leaflet-stompunkt-tooltip',
                        opacity: 0.9,
                        offset: [0, -5],
                        permanent: this.props.permanentTooltips,
                    })
                }
            }
        })
    }

    tooltipElement(feature) {
        const element = document.createElement("b")
        const text = document.createTextNode()
        element.appendChild(text)
        return element
    }

    getData() {
        return {
            type: "FeatureCollection",
            crs: {
                type: "name",
                properties: {
                    name: "urn:ogc:def:crs:EPSG::3006"
                }
            },
            features: this.props.features
        }
    }

    componentDidUpdate() {
        this.layer.clearLayers()
        this.layer.addData(this.getData())
        this.layer.setStyle(this.props.style)
    }

}

export default withMapContext(GeoJsonLayer)


// WEBPACK FOOTER //
// ./src/components/Leaflet/GeoJsonLayer.js